// extracted by mini-css-extract-plugin
export var dots = "style-module--dots--bjuDW";
export var dotsSmall = "style-module--dots-small--HXx-i";
export var green = "style-module--green--z0vH0";
export var grey = "style-module--grey--cm6wz";
export var white = "style-module--white--9y8Dx";